var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#efa6a9",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 478.996 478.996",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 181.758,
    cy: 737.326,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.758,
    cy: 804.926,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.458,
    cy: 887.626,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.158,
    cy: 821.226,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.458,
    cy: 704.726,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.158,
    cy: 696.226,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.958,
    cy: 654.126,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.962,903.127c13,0,23.5-10.6,23.5-23.5c0-13-10.5-23.5-23.5-23.5s-23.5,10.5-23.5,23.5 S225.962,903.127,238.962,903.127z M238.962,871.127c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5c-4.7,0-8.5-3.8-8.5-8.5 S234.262,871.127,238.962,871.127z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.462,805.927c-17.9,0-32.5,14.6-32.5,32.5s14.6,32.5,32.5,32.5c17.9,0,32.5-14.5,32.5-32.5 C164.962,820.527,150.362,805.927,132.462,805.927z M132.462,855.927c-9.6,0-17.5-7.9-17.5-17.5s7.9-17.5,17.5-17.5 c9.6,0,17.5,7.9,17.5,17.5S142.062,855.927,132.462,855.927z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.762,712.627c15.7,0,28.5-12.8,28.5-28.5s-12.8-28.5-28.5-28.5c-15.7,0-28.5,12.8-28.5,28.5 S145.062,712.627,160.762,712.627z M160.762,670.627c7.4,0,13.5,6.1,13.5,13.5s-6.1,13.5-13.5,13.5c-7.4,0-13.5-6.1-13.5-13.5 S153.362,670.627,160.762,670.627z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.062,745.527c0-13-10.5-23.5-23.5-23.5s-23.5,10.5-23.5,23.5s10.5,23.5,23.5,23.5S122.062,758.527,122.062,745.527z  M98.562,754.027c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5S103.262,754.027,98.562,754.027z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.062,757.627c-1.5-1.3-3.5-1.9-5.5-1.7l-172.8,14.8l108.5-136.7c2.6-3.2,2-8-1.2-10.5 c-35.6-28.3-80.2-43.7-125.7-43.1c-45.4,0.5-89.7,16.7-124.8,45.8c-35,29.7-59.2,70.6-67.9,115.3c-8.8,44.9-1.6,91.8,20.1,131.9 c21.3,40.4,56.1,72.4,98,90.3c24.4,10.4,50.4,15.6,76.3,15.6c18.8,0,37.6-2.8,55.7-8.3c43.8-13.2,82.1-41.2,107.8-78.7 c25.7-37.8,37.9-83.7,34.1-129.6C395.462,760.727,394.562,758.927,393.062,757.627z M192.162,775.127c-1.8,2.2-2,5.4-0.6,8.1 c1.4,2.6,4.3,4.2,7.2,3.9l148.8-12.7c3.3,69.2-39.9,130.8-106.8,150.9c-69.5,19.3-141-11.1-173.9-73.9l-0.1-0.1 c-34-61.4-20-139.7,33.1-186.1c54-46.1,129.9-49.2,185.7-7.8L192.162,775.127z M249.362,956.627 c-82.2,25.2-171.5-12.8-212.3-90.4c-41.2-76-22.6-172.2,44.2-228.7c33.8-28,75.6-42.1,117.4-42.1c38.1,0,76.2,11.7,108.2,35.1 l-11.8,14.9c-29.2-21.8-65.3-33.2-101.9-32c-37.5,1.2-74,15.4-103,40.2c-28.4,24.8-47.7,58.9-54.3,95.9 c-6.7,37.2-0.3,75.8,17.9,108.7c17.6,33.5,46.3,60,81,74.6c20.4,8.6,42.4,13,64.6,13c15.3,0,30.6-2.1,45.6-6.2c0.1,0,0.1,0,0.1,0 c36-10.8,67.6-33.8,88.8-64.8c20.4-29.7,30.5-65.7,28.7-101.8l18.7-1.6C384.762,856.327,331.462,931.827,249.362,956.627z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.962,720.027c-5.1-53.5-31.9-103.7-73.5-137.9c-1.6-1.3-3.6-1.9-5.6-1.7s-3.8,1.2-5.1,2.8l-119.3,150.4 c-1.9,2.4-2.1,5.6-0.7,8.2c1.3,2.4,3.9,3.9,6.6,3.9c0.2,0,0.5,0,0.7,0l190.1-17.5c2-0.2,3.8-1.1,5.1-2.7 C478.462,724.027,479.162,722.027,478.962,720.027z M363.962,654.027c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5s-8.5-3.8-8.5-8.5 S359.262,654.027,363.962,654.027z M298.262,729.227l44.6-56.4c3.8,7.8,11.8,13.2,21.1,13.2c13,0,23.5-10.5,23.5-23.5 c0-11.2-7.8-20.5-18.2-22.9l11.5-14.4c26.7,23.9,43.5,55.5,49,91.9L298.262,729.227z M444.662,715.727 c-5.9-40.6-24.7-75.7-54.6-102.3l11.6-14.7c33.4,29.8,55.4,71.1,61.4,115.3L444.662,715.727z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.5cd13503080aaadc908f37604b93a5d7.svg";
export { ForwardRef as ReactComponent };